import { LanguagePack } from './index';
const languagePack: LanguagePack = {
    'lang': 'Russian / Русский',

    'button.ok': 'Да',
    'button.cancel': 'Отмена',
    'button.commit': 'Сохранить',
    "button.save": 'Сохранить',
    'button.find': 'Найти',
    'button.new': 'Создать',
    'button.create': 'Создать',
    'button.edit': 'Редактировать',
    'button.edit_short': 'Ред',
    'button.delete': 'Удалить',
    'button.apply': 'Применить',
    'button.add': 'Добавить',
    'button.clone': 'Копировать',
    'button.close': 'Close',
    'button.view': 'View',

    'search.title': 'Поиск',

    'units.min': 'мин',
    'units.hours': 'час |||| часа |||| часов',

    'column.id': 'Id',
    'column.action': 'Действие',

    'misc.info': 'Инфо',
    'misc.btn_trash_title': 'Удалить выбранные записи',
    'misc.search_results': 'Результаты поиска',
    'misc.no_results': 'Нет данных',
    'misc.nothing_searched_msg': 'Мы ничего не искали',

    'nav.dashboard': 'Главная',
    'nav.overview': 'Overview',
    'nav.spartan_sense_portal_settings': 'Spartan Sense Portal Settings',
    "nav.settings_and_configuration": "Settings & Configuration",
    "nav.timezones": "Timezones",
    'nav.division': 'Подразделения',
    "nav.fleetAdministration": "Fleet Administration: Translation Missing",
    'nav.person': 'Персоны',
    'nav.user_administration': 'User Administration: Translation Missing',
    'nav.serviceAccount': 'Учетные записи',
    'nav.vehicle': 'Машины',
    'nav.sensor': 'Датчики',
    'nav.alarms': 'Alarms',
    "nav.configure": "Configure",
    "nav.reports": "Reports: Missing Translation",
    "nav.canpimanager": "CANPi Manager",
    "nav.registration": "Registration",
    'nav.sign_out': 'Выйти',
    'nav.settings': 'Settings',
    "nav.signed_in_as": "Signed in as ",
    'division_path.working_on': 'Текущее подразделение',
    'division_path.change': 'изменить',
    'division_path.switch_to': 'Переключиться на %{name}',
    'division_path.admin_of': 'Вы администрируете %{name}',
    'dashboard.excess_assignment.title': 'Принять в работу',
    'dashboard.excess_assignment.message': 'Вы будуте назначены ответственным. Назначение будет снято автоматически через:',
    'dashboard.excess_table.column_header.time': 'Время',
    'dashboard.excess_table.column_header.vehicle': 'Машина',
    'dashboard.excess_table.column_header.sensor': 'Датчик',
    'dashboard.excess_table.column_header.quantity': 'Величина',
    'dashboard.excess_table.column_header.value': 'Значение',
    'dashboard.excess_table.column_header.assignee': 'Ответственный',
    'dashboard.excess_table.buttons.vehicle': 'Машина',
    'dashboard.excess_table.buttons.sensor': 'Датчик',
    'dashboard.excess_table.buttons.data': 'Данные',
    'dashboard.excess_table.buttons.iamonit': 'Я займусь',
	'dashboard.excess_table.del_confirmation_title': 'Удалить сообщения',
	'dashboard.excess_table.del_confirmation_msg': 'Удаление невозможно отменить. Продолжить?',
    'dashboard.summary_table.header': 'Сводка по машинам для "%{name}"',
    'dashboard.summary_table.column_header.total': 'Всего',
    'dashboard.summary_table.column_header.live': 'Активные',
    'dashboard.summary_table.column_header.dead': 'Неактивные',
    'dashboard.summary_table.column_header.green_zone': 'Зеленая зона',
    'dashboard.summary_table.column_header.yellow_zone': 'Желтая зона',
    'dashboard.summary_table.column_header.red_zone': 'Красная зона',
    'dashboard.summary_table.column_header.no_levels': 'Без уровней',

    'division.edit_title': 'Редактировать подразделение',
    'division.create_title': 'Создать новое подразделение',
    'division.parent_label': 'Родительское подразделение',
    'division.name_label': 'Имя',
    'division.msg_admin_for': 'Вы администрируете %{name}',
    'division.btn_switch': 'Сменить',
    'division.validation_err.parent_not_set': 'Пожалуйста, выберите родительское подразделение',
    'division.validation_err.empty_name': 'Пожалуйста, укажите имя подразделения',

    'person.edit_title': 'Редактировать персону',
    'person.create_title': 'Создать новую персону',
    'person.label_division': 'Подразделение',
    'person.label_first_name': 'Имя',
    'person.label_last_name': 'Фамилия',
    'person.label_username': 'Имя для входа',
    'person.label_is_administrator': 'полномочия администратора',
    'person.label_password': 'Пароль',
    'person.label_confirm_password': 'Повторите пароль',
    'person.label_level': 'Полномочия',
    'person.label_level_user': 'пользователь',
    'person.label_level_administrator': 'администратор',
    'person.del_confirmation_title': 'Удаление персон',
    'person.del_confirmation_msg': 'Удаление невозможно отменить. Продолжить?',
    'person.validation_err.division_not_set': 'Пожалуйста, выберите подразделение',
    'person.validation_err.empty_first_name': 'Пожалуйста, укажите имя',
    'person.validation_err.empty_username': 'Пожалуйста, укажите имя для входа',
    'person.validation_err.password_mismatch': 'Копии пароля не совпадают',

    'service_account.edit_title': 'Редактировать учетную запись',
    'service_account.create_title': 'Создать новую учетную запись',
    'service_account.label_username': 'Имя для входа',
    'service_account.label_division': 'Подразделение',
    'service_account.label_server_url': 'Адрес сервера',
    'service_account.label_password': 'Пароль',
    'service_account.label_import_vehicles': 'импортировать все машины',
    'service_account.del_confirmation_title': 'Удалить учетные записи',
    'service_account.del_confirmation_msg': 'Это действие также удалит все машины, которые связаны с выбранными учетными записями. Результат будет нельзя отменить.',
    'service_account.validation_err.division_not_set': 'Пожалуйста, укажите подразделение',
    'service_account.validation_err.invalid_server_url': 'Пожалуйста, укажите адрес сервера',

    'vehicle.edit_title': 'Редактировать машину',
    'vehicle.create_title': 'Создать новое машину',
    'vehicle.label_box_id_source': 'Из Box ID',
    'vehicle.label_source': 'Источник',
    'vehicle.label_division': 'Подразделение',
    'vehicle.label_box_id': 'Box ID',
    'vehicle.label_service_account': 'Учетная запись',
    'vehicle.label_vehicle': 'Машина',
    'vehicle.placeholder_vehicle': 'Выберите машину в Geotab',
    'vehicle.label_timezone': 'Часовой пояс',
    'vehicle.placeholder_timezone': 'Выберите часовой пояс машины',
    'vehicle.label_display': 'Отображать как',
    'vehicle.label_tags': 'Теги',
    'vehicle.label_last_data': 'Последняя загрузка',
    'vehicle.placeholder_tags': 'Введите тег',
    'vehicle.prefix_for_tags': 'Добавить новый тег',
    'vehicle.label_native_title': 'Название',
    'vehicle.group_actions': 'Групповые действия',
    'vehicle.no_data_msg': 'Нет данных для выбранных транспортных средств',
    'vehicle.btn_show_on_map': 'Показать выбранные транспортные средства на карте',
    'vehicle.del_confirmation_title': 'Удалить транспортные средства',
    'vehicle.del_confirmation_msg': 'Удаление невозможно отменить. Продолжить?',
    'vehicle.group_actions.no_actions_placeholder': 'Действия не запланированы',
    'vehicle.group_actions.added_actions_title': 'Запланированные действия',
    'vehicle.group_actions.title_select_action': 'Выберите действие',
    'vehicle.group_actions.action_title_add_tags': 'Добавить теги',
    'vehicle.group_actions.action_title_remove_tags': 'Удалить теги',
    'vehicle.group_actions.action_title_set_timezone': 'Задать часовой пояс',
    'vehicle.group_actions.action_title_set_pressure': 'Задать уровни давления',
    'vehicle.group_actions.action_title_set_temperature': 'Задать уровни температуры',
    'vehicle.btn_sensors': 'Датчики',
    'vehicle.msg_import_in_progress': 'Идет импорт. Это займет несколько минут',
    'vehicle.validation_err.division_not_set': 'Пожалуйста, укажите подразделение',
    'vehicle.validation_err.invalid_box_id': 'Указанный Box ID невалиден',
    'vehicle.validation_err.service_account_not_set': 'Пожалуйста, укажите учетную запись',
    'vehicle.validation_err.geotab_vehicle_not_set': 'Пожалуйста, выберите машину в Geotab',

    'sensor.edit_title': 'Редактировать датчик',
    'sensor.create_title': 'Создать новый датчик',
    'sensor.btn_last_24h': 'Прошедшие 24ч',
    'sensor.btn_yesterday': 'Вчера',
    'sensor.btn_go': 'Показать',
    'sensor.placeholder_from': 'с',
    'sensor.placeholder_to': 'по',
    'sensor.label_vehicle': 'Машина',
    'sensor.label_display': 'Отображение',
    'sensor.label_lifetime': 'Срок работы, ч',
    'sensor.label_native_title': 'Название',
    'sensor.label_sensor': 'Датчик',
    'sensor.label_quantity': 'Единица измерения',
    'sensor.del_confirmation_title': 'Удалить датчики',
    'sensor.del_confirmation_msg': 'Удаление невозможно отменить. Продолжить?',
    'sensor.no_data_msg': 'Нет данных за выбраный промежуток времени',
    'sensor.placeholder_vehicle': 'Выберите машину',
    'sensor.placeholder_sensor': 'Выберите датчик',
    'sensor.validation_err.vehicle_not_set': 'Пожалуйста, выберите машину',
    'sensor.validation_err.sensor_not_set': 'Пожалуйста, выберите датчик',
    'sensor.validation_err.quantity_not_set': 'Пожалуйста, укажите единицу измерения',

    'sensors_data.btn_graph': 'График',
    'sensors_data.btn_table': 'Таблица',
    'sensors_data.btn_excel': 'Excel',
    'sensors_data.btn_refresh': 'Refresh',
    'sensors_data.btn_map': 'Карта',
    'sensors_data.tooltip_hint': 'Нажмите Alt для выбора',
    'sensors_data.label_time': 'Время',

    'levels.all_axles': 'все оси',
    'levels.axle_#': 'ось',
    'levels.axles': 'Ось',
    'levels.baseline': 'Уровень',
    'levels.define_alert_levels': 'задать уровни тревоги',
    'levels.red_max': 'Красный макс',
    'levels.red_min': 'Красный мин',
    'levels.yellow_max': 'Желтый макс',
    'levels.yellow_min': 'Желтый мин',

    'settings.title_for': 'Настройки (%{name})',
    'settings.title_measure_units': 'Единицы измерения',
    'settings.title_emails': 'Список уведомлений по электронной почте отдела',
    'settings.title_personal_settings': 'Личные настройки',
    'settings.title_language': 'Язык интерфейса',
    'settings.title_change_password': 'сменить пароль',
    'settings.title_password': 'Пароль',
    'settings.title_confirm_password': 'Подтверждение пароля',
    'settings.validation_err.password_mismatch': 'Копии пароля не совпадают',
    'settings.validation_err.password_not_set': 'Пароль не может быть пустым',

    'login.placeholder_username': 'Имя пользователя',
    'login.placeholder_password': 'Пароль',
    'login.btn_sign_in': 'Войти',
    'login.err_no_response': 'Сервер не отвечает',

    'reports.no_reports_message': 'No reports Available'
};

export default languagePack


// WEBPACK FOOTER //
// ./translations/lang_ru.ts